export const ISSUER = 'rwH49FHnr48FeUP7NX9EuL4k1peLrPwS3d';
export const CURRENCY = '4D41474100000000000000000000000000000000';
// Preserve the existing site's token destinations in one place.
export const links = {
  firstLedger: `https://firstledger.net/token/${ISSUER}/${CURRENCY}`,
  xpmarket: `https://xpmarket.com/token/MAGA-${ISSUER}`,
  xmagnetic: `https://xmagnetic.org/tokens/MAGA+${ISSUER}?network=mainnet`,
  xmagneticSwap: `https://xmagnetic.org/?token=${ISSUER}`,
  chart: 'https://dexscreener.com/xrpl/4d41474100000000000000000000000000000000.rwh49fhnr48feup7nx9eul4k1pelrpws3d_xrp',
  explorer: `https://xrpscan.com/account/${ISSUER}`,
  nft: 'https://xrp.cafe/collection/ultramagaeagle',
  farm: 'https://farmerunion.meme/',
  x: 'https://x.com/Ultra_MAGA_XRPL',
  telegram: 'https://t.me/UltraMAGAXRPL',
  tiktok: 'https://www.tiktok.com/@ultra_maga_xrpl',
  game: '/flappytrump/',
  arcade: '/games/crossing-the-swamp/',
};
// Existing published figures; these are not a live market feed.
export const tokenStats = [
  { label: 'Total supply', value: '99.9M', detail: '$MAGA', icon: 'token' },
  { label: 'Circulating supply', value: '90.8M', detail: '$MAGA', icon: 'chart' },
  { label: 'Liquidity', value: 'Locked', detail: 'Project reported', icon: 'lock' },
  { label: 'Issuer', value: 'Blackholed', detail: 'View on XRPSCAN', icon: 'shield', href: links.explorer },
];
